import { ButtonIcon } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useIsDraftSprintReadyToStart } from 'features/planning/hooks/useIsDraftSprintReadyToStart';
import { useSprintStartSubmit } from 'features/sprint/hooks';

export const PlanningDraftSprintHeaderStartButton = ({
  sprintId,
  sprintChallengesCount,
  sprintTitle,
}: {
  sprintId: string;
  sprintChallengesCount: number;
  sprintTitle: string;
}) => {
  const isSprintReadyToStart = useIsDraftSprintReadyToStart({
    sprintChallengesCount,
    sprintTitle,
  });
  const onStartSprintButtonClick = useSprintStartSubmit({
    sprintId,
  });

  if (!isSprintReadyToStart) {
    return null;
  }

  return (
    <ButtonIcon
      aria-label="start sprint"
      onClick={onStartSprintButtonClick}
      variant="ghost"
      data-testid="start-sprint-button"
    >
      <Icon name={iconNames.play} width="16px" height="16px" />
    </ButtonIcon>
  );
};
